<template>
	<div>
		<div class="association-btn">
			<el-button :type="curBtnType == 'gj' ? 'primary' : ''" @click="changeBtnType('gj')">归集核对</el-button>
			<el-button :type="curBtnType == 'js' ? 'primary' : ''" @click="changeBtnType('js')">结算核对</el-button>
			<el-divider direction="vertical"></el-divider>
			<el-button type="primary" @click="allCheck">系统一键核对</el-button>
			<div class="gl-btn" v-loading="associationState">
				<el-button @click="association" type="success">核 对</el-button>
				<el-radio-group v-model="selectState">
					<el-radio :label="item.label" v-for="(item, index) in resultStateOptions" :key=index></el-radio>
				</el-radio-group>
			</div>
		</div>
		<el-divider class="m5"></el-divider>
		<div class="match-box">
			<div class="item">
				<div class="title-box">
					<div class="title">{{ curBtnType == 'gj' ? '归集主账户收入明细' : '结算明细' }}</div>
				</div>

				<div class="select-box">
					<div class="select-item w30">
						<div class="select-label">时间</div>
						<div class="select-value">
							<el-date-picker v-model="leftDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
								type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</div>
					</div>
					<div class="select-item w30">
						<el-input placeholder="请输入内容" v-model="leftSearchStr" class="input-with-select" clearable>
							<el-select v-model="leftSearchType" slot="prepend" placeholder="请选择" class="w200">
								<template v-if="curBtnType == 'gj'">
									<el-option label="账户名称" value="accountName"></el-option>
									<el-option label="账号/卡号" value="account"></el-option>
								</template>
								<template v-else>
									<el-option label="店铺" value="shopName"></el-option>
								</template>
							</el-select>
						</el-input>
					</div>
					<div class="select-item w30">
						<div class="select-label">金额</div>
						<el-input placeholder="请输入内容" v-model="leftSearchAmount" class="input-with-select"
							clearable></el-input>
					</div>
					<div class="select-item w25">
						<div class="select-label">币种</div>
						<el-select class="select-value" v-model="leftSearchCurrency" slot="prepend" placeholder="请选择"
							filterable clearable>
							<el-option :label="item.currencyCode" :value="item.currencyCode"
								v-for="item in currencyOptions" :key=item.id></el-option>
						</el-select>
					</div>
					<div class="select-item w25">
						<div class="select-label">状态</div>
						<el-select class="select-value" v-model="leftSearchState" slot="prepend" placeholder="请选择"
							filterable clearable>
							<el-option :label="item.label" :value="item.value" v-for="(item, index) in stateOptions"
								:key=index></el-option>
						</el-select>
					</div>
					<div class="select-item w25" v-if="curBtnType == 'js'">
						<div class="select-label">平台</div>
						<el-select v-model="selectPlatform" placeholder="请选择" class="select-value" filterable @change="getSettlementData">
							<el-option v-for="item in platformList" :key="item.id" :label="item.itemTypeName"
								:value="item.itemTypeId"></el-option>
						</el-select>
					</div>
					<div class="select-item  w25" v-if="curBtnType == 'gj'">
						<div class="select-label">核对结果</div>
						<el-select class="select-value" v-model="leftSearchResultState" slot="prepend" placeholder="请选择"
							filterable clearable>
							<el-option :label="item.label" :value="item.value"
								v-for="(item, index) in resultStateOptions" :key=index></el-option>
						</el-select>
					</div>
					<div class="select-item  w25">
						<el-button type="primary" @click="leftSearchData">查询</el-button>
						<el-button type="primary" @click="leftInitData">重置</el-button>
						<el-button type="primary" @click="cancelSelectLeft">取消选择</el-button>
					</div>
				</div>
				<el-table stripe :data="leftTableData" border tooltip-effect="dark" highlight-current-row
					@current-change="handleLeftCurrentSelectChange" style="width: 100%" height="calc(100% - 150px)"
					ref="leftTable">
					<!-- <el-table-column type="index" width="45"></el-table-column> -->
					<el-table-column :label="h.label" :prop="h.prop" :width="h.width" v-for="h in leftTableHeader"
						:fixed="h.fixed" :key="h.prop">
						<template slot-scope="scope">
							<span v-if="h.prop == 'reconciliationStatus'"
								:class="scope.row[h.prop] == '已对账' ? 'green-text' : 'red-text'">
								{{ scope.row[h.prop] }}
								<el-button type="text" v-if="scope.row[h.prop] == '已对账'"
									@click="editRow(scope.row, 'masterDetailId')">操作</el-button>
							</span>
							<span v-else-if="h.prop == 'reconciliationResult'"
								:class="scope.row[h.prop] && scope.row[h.prop].includes('异常') ? 'red-text' : 'green-text'">
								{{ scope.row[h.prop] }}
							</span>
							<span v-else>
								{{ scope.row[h.prop] }}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="状态" width="80" v-if="curBtnType == 'js'">
						<template slot-scope="scope">
							<span :class="scope.row['reviewStatus'] == 0 ? 'red-text' : 'green-text'">
								{{ scope.row['reviewStatus'] == 0 ? '未对账' : '已对账' }}
							</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="page-block">
					<el-pagination @size-change="handleLeftSizeChange" @current-change="handleLeftCurrentPageChange"
						:current-page="leftPage" :page-sizes="[20, 50, 100, 200, 300, 500]" :page-size="leftSize"
						layout="total, sizes, prev, pager, next, jumper" :total="leftTotal">
					</el-pagination>
				</div>
			</div>

			<el-divider direction="vertical"></el-divider>
			<div class="item">
				<div class="title-box">
					<div class="title">{{ curBtnType == 'gj' ? '归集子账户支出明细' : '收支明细' }}</div>
				</div>
				<div class="select-box">
					<div class="select-item w30">
						<div class="select-label">时间</div>
						<div class="select-value">
							<el-date-picker v-model="rightDate" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
								type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
							</el-date-picker>
						</div>
					</div>
					<div class="select-item w30">
						<el-input placeholder="请输入内容" v-model="rightSearchStr" class="input-with-select" clearable>
							<el-select v-model="rightSearchType" slot="prepend" placeholder="请选择" class="w200">
								<el-option label="账户名称" value="accountName"></el-option>
								<el-option label="账号/卡号" value="account"></el-option>
							</el-select>
						</el-input>
					</div>
					<div class="select-item w30">
						<div class="select-label">金额</div>
						<el-input placeholder="请输入内容" v-model="rightSearchAmount" class="input-with-select"
							clearable></el-input>
					</div>
					<div class="select-item w25">
						<div class="select-label">币种</div>
						<el-select class="select-value" v-model="rightSearchCurrency" slot="prepend" placeholder="请选择"
							filterable clearable>
							<el-option :label="item.currencyCode" :value="item.currencyCode"
								v-for="item in currencyOptions" :key=item.id></el-option>
						</el-select>
					</div>
					<div class="select-item w25">
						<div class="select-label">状态</div>
						<el-select class="select-value" v-model="rightSearchState" slot="prepend" placeholder="请选择"
							filterable clearable>
							<el-option :label="item.label" :value="item.value" v-for="(item, index) in stateOptions"
								:key=index></el-option>
						</el-select>
					</div>
					<div class="select-item  w25">
						<div class="select-label">核对结果</div>
						<el-select class="select-value" v-model="rightSearchResultState" slot="prepend"
							placeholder="请选择" filterable clearable>
							<el-option :label="item.label" :value="item.value"
								v-for="(item, index) in resultStateOptions" :key=index></el-option>
						</el-select>
					</div>
					<div class="select-item w25">
						<el-button type="primary" @click="rightSearchData">查询</el-button>
						<el-button type="primary" @click="rightInitData">重置</el-button>
						<el-button type="primary" @click="cancelSelectRight">取消选择</el-button>
					</div>
				</div>
				<el-table stripe :data="rightTableData" border tooltip-effect="dark" style="width: 100%"
					highlight-current-row @current-change="handleRightCurrentSelectChange" height="calc(100% - 150px)"
					ref="rightTable">
					<!-- <el-table-column type="index" width="45"></el-table-column> -->
					<el-table-column :label="h.label" :prop="h.prop" :width="h.width" v-for="h in detailHeader"
						:fixed="h.fixed" :key="h.prop">
						<template slot-scope="scope">
							<span v-if="h.prop == 'reconciliationStatus'"
								:class="scope.row[h.prop] == '已对账' ? 'green-text' : 'red-text'">
								{{ scope.row[h.prop] }}
								<el-button type="text" v-if="scope.row[h.prop] == '已对账'"
									@click="editRow(scope.row, curBtnType == 'gj' ? 'subDetailId' : 'masterDetailId')">操作</el-button>
							</span>
							<span v-else-if="h.prop == 'reconciliationResult'"
								:class="scope.row[h.prop] && scope.row[h.prop].includes('异常') ? 'red-text' : 'green-text'">
								{{ scope.row[h.prop] }}
							</span>
							<span v-else>
								{{ scope.row[h.prop] }}
							</span>
						</template>
					</el-table-column>
				</el-table>
				<div class="page-block">
					<el-pagination @size-change="handleRightSizeChange" @current-change="handleRightCurrentPageChange"
						:current-page="rightPage" :page-sizes="[20, 50, 100, 200, 300, 500]" :page-size="rightSize"
						layout="total, sizes, prev, pager, next, jumper" :total="rightTotal">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="提示" :visible.sync="editDialog" width="80%" :before-close="handleClose">
			<div>
				<el-button type="primary" @click="cancelCheck" style="margin-bottom: 10px;">取消核对</el-button>

				<!-- 收支明细的表格弹窗 -->
				<el-table stripe :data="editData['data']" border tooltip-effect="dark" style="width: 100%"
					height="calc(100% - 150px)" v-if="curBtnType == 'gj'">
					<el-table-column :label="h.label" :prop="h.prop" v-for="h in detailHeader" :key="h.prop">
						<template slot-scope="scope">
							<span v-if="h.prop == 'reconciliationStatus'"
								:class="scope.row[h.prop] == '已对账' ? 'green-text' : 'red-text'">
								{{ scope.row[h.prop] }}
							</span>
							<span v-else-if="h.prop == 'reconciliationResult'"
								:class="scope.row[h.prop] && scope.row[h.prop].includes('异常') ? 'red-text' : 'green-text'">
								{{ scope.row[h.prop] }}
							</span>
							<span v-else>
								{{ scope.row[h.prop] }}
							</span>
						</template>
					</el-table-column>
				</el-table>

				<!-- 结算数据的表格弹窗 -->
				<el-table stripe :data="editData['data']" border tooltip-effect="dark" style="width: 100%"
					height="calc(100% - 150px)" v-if="curBtnType == 'js'">
					<!-- <el-table-column type="index" width="45"></el-table-column> -->
					<el-table-column :label="h.label" :prop="h.prop" v-for="h in dialogJsTableHeader" :key="h.prop">
						<template slot-scope="scope">
							<span v-if="h.prop == 'reconciliationStatus'"
								:class="scope.row[h.prop] == '已对账' ? 'green-text' : 'red-text'">
								{{ scope.row[h.prop] }}
								<el-button type="text" v-if="scope.row[h.prop] == '已对账'"
									@click="editRow(scope.row, 'masterDetailId')">操作</el-button>
							</span>
							<span v-else-if="h.prop == 'reconciliationResult'"
								:class="scope.row[h.prop] && scope.row[h.prop].includes('异常') ? 'red-text' : 'green-text'">
								{{ scope.row[h.prop] }}
							</span>
							<span v-else>
								{{ scope.row[h.prop] }}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="状态" width="80" v-if="curBtnType == 'js'">
						<template slot-scope="scope">
							<span :class="scope.row['reviewStatus'] == 0 ? 'red-text' : 'green-text'">
								{{ scope.row['reviewStatus'] == 0 ? '未对账' : '已对账' }}
							</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="handleClose">关 闭</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import { ajaxGet, ajaxPost, Baseurl } from '@/api/api/api.js';
export default {
	name: 'DetailedCheck',
	props: {},
	data() {
		return {
			selectState: '正常',
			curBtnType: '',
			multipleSelection: [],
			companyOpts:[],
			selectCompany: '',
			shopOpts:[],
			dictionaryMap: {},
			searchStr: '',
			leftTableData: [],
			leftTotal: 0,
			leftPage: 1,
			leftSize: 20,
			rightPage: 1,
			rightSize: 20,
			rightTotal: 0,
			loadAccoutData: false,
			rightSelect: null,
			leftSelect: null,
			associationState: false,
			leftDate: '',
			leftSearchStr: '',
			leftSearchCurrency: '',
			leftSearchType: 'accountName',
			leftSearchAmount: '',
			leftSearchState: '未对账',
			leftSearchResultState: '', 

			rightSearchStr: '',
			rightSearchType: 'accountName',
			rightSearchAmount: '',
			rightSearchState: '未对账',
			rightTableData: [],
			rightSearchResultState: '',
			selectPlatform: '', //平台

			detailHeader:[
				{ prop: 'transactionId', label: '交易id', align: 'center', width: 150 },
				{ prop: 'amount', label: '交易金额', align: 'center', width: 100 },
				{ prop: 'transactionParty', label: '交易方', align: 'center', width: 130 },
				{ prop: 'tradingAccount', label: '交易账号', align: 'center', width: 130 },
				{ prop: 'currency', label: '币种', align: 'center', width: 60 },
				// { prop: 'incomeExpenditure', label: '收入/支出', align: 'center', width: 80 },
				{ prop: 'description', label: '描述', align: 'center', width: 150 },
				{ prop: 'tradingTime', label: '交易时间', align: 'center', width: 100 },
				{ prop: 'accountType', label: '账户类型', align: 'center', width: 120 },
				// { prop: 'accountNature', label: '账户性质', align: 'center', width: 100 },
				{ prop: 'accountName', label: '账户名称', align: 'center', width: 100 },
				{ prop: 'account', label: '账号/卡号', align: 'center', width: 130 },
				{ prop: 'reconciliationStatus', label: '状态', align: 'center', width: 80, fixed: 'right' },
				{ prop: 'reconciliationResult', label: '核对结果', align: 'center', width: 90, fixed: 'right' },
				// { prop: 'createTime', label: '创建时间', align: 'center', width: 100 },
			],
			settlementHeader: [],

			stateOptions: [
				{ label: '已对账', value: '已对账'},
				{ label: '未对账', value: '未对账'},
			],
			resultStateOptions: [
				{ label: '正常', value: '正常' },
				{ label: '异常', value: '异常' },
				{ label: '归集异常', value: '归集异常' },
			],
			platformList: [], //平台列表
			selectShop: '',
			editDialog: false,
			editData: {},
			rightDate: '',
			currencyOptions: [],
			rightSearchCurrency: '',
			platformMap: {},
			dialogJsTableHeader: [],
		};
	},
	watch: {},
	created() {
		this.getBizhong()
	},
	mounted() {
		this.changeBtnType('gj');
		this.getPlatformList();
	},
	computed: {
		
		leftTableHeader(){
			if(this.curBtnType == 'gj'){
				return this.detailHeader
			}else{
				this.$nextTick(() => {
					this.$refs.leftTable.doLayout()
				});
				return this.getJsHeader(this.selectPlatform);
			}
		},
	},
	methods: {
		getJsHeader(sellerType){
			if(sellerType == '1'){ //亚马逊
				return [
					{ label: '报告文档id', prop: 'reportDocumentId', width: 100},
					{ label: '结算id', prop: 'settlementId', width: 100},
					{ label: '结算开始时间', prop: 'settlementStartDate', width: 100},
					{ label: '结算结束时间', prop: 'settlementEndDate', width: 100},
					{ label: '付款时间', prop: 'depositDate', width: 100},
					{ label: '总金额', prop: 'totalAmount', width: 100},
					{ label: '币种', prop: 'currency', width: 100},
					{ label: '卖家id', prop: 'sellerId'},
					{ label: '店铺名称', prop: 'shopName'},
				]
			}else{
				return [
					{ label: '卖家id', prop: 'sellerId'},
					{ label: '付款金额', prop: 'amount'},
					{ label: '币种', prop: 'currency', width: 100},
					{ label: '付款时间', prop: 'depositDate', width: 100},
					{ label: '结算开始时间', prop: 'settlementStartDate', width: 100},
					{ label: '结算结束时间', prop: 'settlementEndDate', width: 100},
					{ label: '店铺名称', prop: 'shopName'},
				]
			}
		},
		getBizhong() {
			const API = Baseurl + 'rateController/getAllRate'
			ajaxPost(API).then(res => {
				const { code, data } = res.data
				if (code === 200) {
					this.currencyOptions = data
				} else {
					this.$message.error(data)
				}
			})
		},
		handleClose() {
			this.editData = {};
			this.editDialog = false;
		},
		cancelCheck(){
			this.$confirm("确定取消吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning",
			}).then(() => {
				if(this.editData['data'].length == 0){
					return;
				}
				let params = {
					[this.editData['key']]: this.editData['outId'],
					"relatedDetailIds": this.editData['data'].map(item => item.id)
				}
				let api = '';
				if(this.curBtnType == 'js'){ //结算
					api = 'incomeExpenditureDetailsRelatedController/cancelSettlementCheck';
					params = {
						"masterDetailId": this.editData['outId'],
						"settlementId": this.editData['data'][0]['id'],
						"sellerType": this.editData['data'][0]['sellerType'],
					}
				}else{
					api = 'incomeExpenditureDetailsRelatedController/cancelCheck'
				}
				ajaxPost(Baseurl + api, params).then((resp) => {
					if (resp.status === 200) {
						const res = resp.data;
						if (res.code === 200) {
							this.$message.success('取消核对成功');
							this.handleClose();
							this.leftSearchData();
							this.rightSearchData();
						} else {
							this.$message.error(res.message)
						}
					}
				})
			}).catch(() => {
				this.cancelSelectAccount();
			});
		},
		editRow(data, key){
			const params = {
				[key]: data['id'],
			}
			if(this.curBtnType == 'js'){
				// params['sellerType'] = this.selectPlatform;
			}
			ajaxPost(Baseurl + 'incomeExpenditureDetailsRelatedController/selectIncomeExpenditureDetailsRelated', params).then((resp) => {
				if (resp.status === 200) {
					const res = resp.data;
					if (res.code === 200) {
						if(this.curBtnType == 'gj'){
							this.editData = {
								data: res.data.relatedDetails,
								key,
								outId: data['id'],
							}
						} else if (this.curBtnType == 'js'){
							let data2 = [];
							if(res.data.amazonOrderSettlements.length > 0){
								data2 = res.data.amazonOrderSettlements;
								this.dialogJsTableHeader = this.getJsHeader('1');
							}else{
								data2 = res.data.sellerPayments.filter(item => item);
								this.dialogJsTableHeader = this.getJsHeader('0');
							}
							this.editData = {
								data: data2,
								key,
								outId: data['id'],
							}
						}
						this.editDialog = true;
					} else {
						this.$message.error(res.message)
					}
				}
			})
		},
		getPlatformList() {
			ajaxPost(Baseurl + 'purchaseController/selectItemList', { itemCode: 'HYXUN0000014' }).then((resp) => {
				if (resp.status === 200) {
					const res = resp.data;
					if (res.code === 200) {
						const res1 = res.data;
						const obj = {};
						for(let i = 0; i < res1.length; i++){
							obj[res1[i]['itemTypeName']] = res1[i]['itemTypeId'];
						}
						this.platformMap = obj;
						this.platformList = res.data;
					} else {
						this.$message.error(res.message)
					}
				}
			})
		},
		// 获取归集父账号数据
		async getParentData(){
			const params = {
				page: this.leftPage,
				size: this.leftSize,
				parentType: 'parent',
				incomeExpenditure: '收入'
			}
			if (this.leftDate) {
				params['startTime'] = this.leftDate[0] + " 00:00:00";
				params['endTime'] = this.leftDate[1] + " 23:59:59";
			}
			if (this.leftSearchStr) {
				params['searchType'] = this.leftSearchType;
				params['searchStr'] = this.leftSearchStr;
			}
			if (this.leftSearchCurrency) {
				params['currency'] = this.leftSearchCurrency;
			}
			if(this.leftSearchState){
				params['reconciliationStatus'] = this.leftSearchState;
			}
			if (this.leftSearchResultState) {
				params['reconciliationResult'] = this.leftSearchResultState;
			}
			if (this.leftSearchAmount){
				params['amount'] = this.leftSearchAmount;
			}
			this.getDetailData(params).then((result) => {
				this.leftTableData = result.data;
				this.leftTotal = result.total;
				this.$nextTick(() => {
					this.$refs.leftTable.doLayout()
				});
			})
		},
		// 获取归集子账号数据
		async getChildrenData(){
			const params = {
				page: this.rightPage,
				size: this.rightSize,
				parentType: 'child',
				incomeExpenditure: '支出'
			}
			if (this.rightDate){
				params['startTime'] = this.rightDate[0] + " 00:00:00";
				params['endTime'] = this.rightDate[1] + " 23:59:59";
			}
			if (this.rightSearchStr) {
				params['searchType'] = this.rightSearchType;
				params['searchStr'] = this.rightSearchStr;
			}
			if(this.rightSearchCurrency){
				params['currency'] = this.rightSearchCurrency;
			}
			if (this.rightSearchState) {
				params['reconciliationStatus'] = this.rightSearchState;
			}
			if (this.rightSearchResultState) {
				params['reconciliationResult'] = this.rightSearchResultState;
			}
			if (this.rightSearchAmount){
				params['amount'] = this.rightSearchAmount;
			}
			this.getDetailData(params).then((result) => {
				this.rightTableData = result.data;
				this.rightTotal = result.total;
				this.$nextTick(() => {
					this.$refs.rightTable.doLayout()
				});
			})
		},
		// 左边查询
		leftSearchData(){
			if(this.curBtnType == 'gj'){
				this.getParentData();
			}else{
				this.getSettlementData();
			}
		},
		// 左边重置
		leftInitData() {
			this.leftPage = 1;
			this.leftSize = 20;
			this.leftDate = '';
			if(this.curBtnType == 'gj'){
				this.leftSearchType = 'accountName';
			}else{
				this.leftSearchType = 'shopName';
			}
			this.leftSearchStr = '';
			this.leftSearchState = '未对账';
			this.leftSearchResultState = '';
			this.leftSearchCurrency = '';
			this.leftSearchAmount = '';
			
			this.selectPlatform = this.platformList[0] ? this.platformList[0].itemTypeId : '';
			if (this.curBtnType == 'gj') {
				this.getParentData();
			} else {
				this.getSettlementData();
			}
		},

		// 右边查询
		rightSearchData(){
			if(this.curBtnType == 'gj'){
				this.getChildrenData();
			}else{
				this.getDetail();
			}
		},
		// 右边重置
		rightInitData() {
			this.rightPage = 1;
			this.rightSize = 20;
			this.rightDate = '';

			this.rightSearchType = 'accountName';
			this.rightSearchStr = '';
			this.rightSearchAmount = '';
			this.rightSearchState = '未对账';
			this.rightSearchResultState = '';
			this.rightSearchCurrency = '';
			if (this.curBtnType == 'gj') {
				this.getChildrenData();
			} else {
				this.getDetail();
			}
		},
		// 获取结算数据
		async getSettlementData(){
			if(!this.selectPlatform){
				this.$message.error('请选择平台');
				return;
			}
			const params = {
				page: this.leftPage,
				size: this.leftSize,
			}
			if (this.leftSearchStr){ //店铺和金额
				let key = this.leftSearchType;
				params[key] = this.leftSearchStr;
			}
			if(this.leftSearchAmount){
				params['amount'] = this.leftSearchAmount;
			}
			if (this.leftDate) {
				params['startTime'] = this.leftDate[0] + " 00:00:00";
				params['endTime'] = this.leftDate[1] + " 23:59:59";
			}
			if(this.leftSearchState){
				params['reviewStatus'] = this.leftSearchState === '已对账' ? 1 : 0;
			}
			if(this.leftSearchCurrency){
				params['currency'] = this.leftSearchCurrency;
			}
			params['sellerType'] = this.selectPlatform;
			let api = '';
			if(this.selectPlatform == '1'){
				api = 'incomeExpenditureDetailsController/selectAmazonSettlementPage'
			}else{
				api = 'incomeExpenditureDetailsController/selectSellerPaymentPage'
			}
			const resp = await ajaxPost(Baseurl + api, params)
			if (resp.status === 200) {
				const res = resp.data;
				if (res.code === 200) {
					this.leftTableData = res.data.list;
					this.leftTotal = res.data.total;
					this.$nextTick(() => {
						this.$refs.leftTable.doLayout()
					});
				} else {
					this.$message.error(res.message)
				}
			}
			
		},
		// 查询收支明细
		async getDetail() {
			const params = {
				page: this.rightPage,
				size: this.rightSize,
				// parentType: 'parent',
				incomeExpenditure: '收入'
			}
			if (this.rightDate) {
				params['startTime'] = this.rightDate[0] + " 00:00:00";
				params['endTime'] = this.rightDate[1] + " 23:59:59";
			}
			if (this.rightSearchStr) {
				params['searchType'] = this.rightSearchType;
				params['searchStr'] = this.rightSearchStr;
			}
			if (this.rightSearchCurrency) {
				params['currency'] = this.rightSearchCurrency;
			}
			if (this.rightSearchState) {
				params['reconciliationStatus'] = this.rightSearchState;
			}
			if (this.rightSearchResultState) {
				params['reconciliationResult'] = this.rightSearchResultState;
			}
			if (this.rightSearchAmount) {
				params['amount'] = this.rightSearchAmount;
			}
			this.getDetailData(params).then((result) => {
				this.rightTableData = result.data;
				this.rightTotal = result.total;
				this.$nextTick(() => {
					this.$refs.rightTable.doLayout()
				});
			})
		},
		// 获取收支明细
		async getDetailData(params){
			const obj1 = {
				...params,
				"timeType": 'tradingTime'
			}
			const resp = await ajaxPost(Baseurl + 'incomeExpenditureDetailsController/selectIncomeExpenditureDetailsPage', obj1)
			const result = {
				data: [],
				total: 0
			}
			if (resp.status === 200) {
				const res = resp.data;
				if (res.code === 200) {
					const data = res.data;
					result.data = data.list;
					result.total = data.total;
				} else {
					this.$message.error(res.message);
				}
			}
			return result
		},

		// 切换按钮
		changeBtnType(type){
			if(this.curBtnType == type) return;
			this.curBtnType = type;
			this.cancelSelectLeft();
			this.cancelSelectRight();
			this.leftInitData();
			this.rightInitData();
		},
		// 系统一键核对
		allCheck(){
			let api = '';
			if(this.curBtnType == 'gj') {
				api = 'incomeExpenditureDetailsController/systemOneClickVerificationCollectingData';
			} else {
				api = 'incomeExpenditureDetailsController/systemOneClickVerificationSettlementData';
			}
			ajaxGet(Baseurl + api).then((resp) => {
				if (resp.status === 200) {
					const res = resp.data;
					if (res.code === 200) {
						this.$message.success('核对成功');
						this.leftInitData();
						this.rightInitData();
					} else {
						this.$message.error(res.message)
					}
				}
			})
		},
		// 左边表格取消选中
		cancelSelectLeft(){
			this.$refs.leftTable && this.$refs.leftTable.setCurrentRow();
			this.leftSelect = null;
		},
		// 右边表格取消选中
		cancelSelectRight(){
			this.$refs.rightTable && this.$refs.rightTable.setCurrentRow();
			this.rightSelect = null;
		},
		// 关联
		association(){
			if (!this.rightSelect && !this.leftSelect) {
				this.$message.warning('请选择左边或右边表格数据');
				return;
			}
			if (this.selectState == '正常' && (!this.rightSelect || !this.leftSelect)) {
				this.$message.warning('请选择需要关联的数据');
				return;
			}
			this.associationState = true;
			let params = {}
			let api = '';
			if(this.curBtnType == 'gj'){ //归集核对
				api = 'incomeExpenditureDetailsController/manualCheckIncomeExpenditureDetails';
				if (this.leftSelect){
					params['id'] = this.leftSelect.id;
				}
				if (this.rightSelect) {
					params['detailId'] = this.rightSelect.id;
				}
			}else{ //结算核对
				api = 'incomeExpenditureDetailsController/manualCheckSettlementData';
				if (this.rightSelect) {
					params['id'] = this.rightSelect.id;
				}
				if (this.leftSelect) {
					params['settlementId'] = this.leftSelect.id;
				}
				params['sellerType'] = this.selectPlatform;
			}
			params['reconciliationResult'] = this.selectState;
			ajaxPost(Baseurl + api, params).then((resp) => {
				if (resp.status === 200) {
					const res = resp.data;
					if (res.code === 200) {
						this.$message.success('操作成功');
						// this.companyOpts = res.data;
					} else {
						this.$message.error(res.message)
					}
					this.leftSearchData();
					this.rightSearchData();
				}
				this.associationState = false;
			})
		},
		// 左边表格改变当前页显示多少条
		handleLeftSizeChange(val) {
			this.leftPage = 1;
			this.leftSize = val;
			if(this.curBtnType == 'gj'){
				this.getParentData();
			}else{
				this.getSettlementData();
			}
		},
		// 左边当前页改变
		handleLeftCurrentPageChange(val) {
			this.leftPage = val;
			if (this.curBtnType == 'gj') {
				this.getParentData();
			} else {
				this.getSettlementData();
			}
		},

		// 右边表格改变当前页显示多少条
		handleRightSizeChange(val) {
			this.rightPage = 1;
			this.rightSize = val;
			if (this.curBtnType == 'gj') {
				this.getChildrenData();
			}else{
				this.getDetail();
			}
		},
		handleRightCurrentPageChange(val) {
			this.rightPage = val;
			if (this.curBtnType == 'gj') {
				this.getChildrenData();
			} else {
				this.getDetail();
			}
		},

		// 左边表格选中行
		handleLeftCurrentSelectChange(row){
			this.leftSelect = row;
		},
		// 右边表格选中行
		handleRightCurrentSelectChange(row){
			this.rightSelect = row;
		},
		
	},
	
};
</script>
<style lang="scss" scoped>
.match-box{
	display: flex;
	justify-content: space-between;
	width: 100%;
	height: calc(100vh - 180px);
	.item{
		width: calc((100% - 20px) / 2);
		.title-box{
			position: relative;
			.platform-box{
				position: absolute;
				left: 0;
				top: 0;
				display: flex;
				align-items: center;
			}
			.title{
				text-align: center;
				font-size: 16px;
				font-weight: bold;
				margin-bottom: 10px;
			}
		}
		.select-box {
			display: flex;
			flex-wrap: wrap;
			margin-bottom: 10px;
			.el-date-editor{
				width: 150px;
				flex: 1;
				display: flex;
				align-items: center;
				/deep/ .el-input__icon{
					line-height: normal;
					position: relative
				}
				/deep/ .el-range-separator, /deep/ .el-range-input{
					line-height: normal;
				}
				/deep/ .el-input__icon::before, /deep/.el-input__icon::after {
					// content: '';
					position: absolute;
					top: 50%;
					left: 50%;
					transform: translate(-50%, -50%);
					/* 示例样式 */
					// width: 10px;
					// height: 10px;
					// background: red;
				}
			}

			.select-item {
				width: calc(50% - 5px);
				display: flex;
				align-items: center;
				margin-right: 10px;
				margin-bottom: 5px;
				&:nth-child(3n) {
					margin-right: 0;
				}
				&:nth-last-of-type(-n+2){
					margin-bottom: 0;
				}
				&.w30{
					width: calc((100% - 20px) / 3);
					// margin-right: 10px;
					// &:last-child{
					// 	margin-right: 0;
					// }
					// &:nth-child(3n) {
					// 	margin-right: 0;
					// }
				}
				&.w25{
					width: calc((100% - 30px) / 4);
					margin-right: 10px;
					&:last-child{
						margin-right: 0;
					}
				}
				.el-button{
					padding: 5px 10px;
				}
				.w200{
					width: 120px;
				}
				.select-value{
					flex: 1;
					display: flex;
					align-items: center;
				}
				.select-label{
					flex-shrink: 0;
				}
				.select-label {
					margin-right: 5px;
				}

				.el-select {
					// width: 250px;

					&.w800 {
						width: 800px;
					}
				}
			}
		}

	}
	.el-divider{
		height: 100%;
		margin: 0;
	}
	.page-block {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 10px;
	}
	/deep/ .current-row .el-table__cell{
		background-color: #b4d8ff !important;
	}
}
.association-btn {
	height: 30px;
	width: 100%;
	display: flex;
	// justify-content: center;
	align-items: center;
	position: relative;
	.el-divider{
		height: 100%;
	}
	.gl-btn{
		.el-button{
			width: 100px;
			margin-right: 20px;
		}
		display: flex;
		align-items: center;
		position: absolute;
		top: 0;
		left:50%;
		transform: translateX(-50%);
	}
}
.m5{
	margin: 5px 0;
}
.el-table .cell{
	.list-item{
		padding-left: 10px;
		line-height: 20px;
		position: relative;
		&::after{
			content: '';
			width: 7px;
			height: 7px;
			background-color: #414141;
			border-radius: 50%;
			position: absolute;
			left: 0;
			top: 7px;
		}
	}
}
/deep/ .el-table--enable-row-hover .el-table__body tr:hover>td {
	background-color: transparent;
}
.green-text{
	color: #67c23a;
	.el-button{
		padding: 0;
	}
}
.red-text{
	color: #f56c6c;
}
</style>